import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import Loader from '../common/Loader/Loader';
import {
  fetchWellSummaryDashboard,
  fetchFilteredWellSummary,
  selectWellSummaryLoading,
  selectWellSummaryError,
  selectWellDashboardRaw,
} from './WellSummaryDashboardSlice';
import { WellStatusGrid } from './WellStatusGrid';
import './WellStatusWidget.scss';

type WellStatusWidgetProps = {
  filters?: {
    mops?: string[];
    businessUnits?: string[];
    fields?: string[];
    groups?: string[];
  };
};

export default function WellStatusWidget({ filters }: WellStatusWidgetProps) {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectWellSummaryLoading);
  const error = useAppSelector(selectWellSummaryError);
  const dashboardData = useAppSelector(selectWellDashboardRaw);

  // Initial load or when filters change
  useEffect(() => {
    if (filters && Object.keys(filters).length > 0) {
      dispatch(
        fetchFilteredWellSummary({
          mops: filters.mops?.join(',') || '',
          businessUnits: filters.businessUnits?.join(',') || '',
          fields: filters.fields?.join(',') || '',
          groups: filters.groups?.join(',') || '',
        }),
      );
    } else if (!dashboardData && !loading) {
      dispatch(fetchWellSummaryDashboard());
    }
  }, [dispatch, filters, dashboardData, loading]);

  return (
    <div className='well-status-container'>
      <div className='wsw-headerWrap'>
        <div className='wsw-header'>
          <div className='wsw-headerLeft'>
            <div className='wsw-titleRow'>
              <span className='wsw-title'>Well status</span>
            </div>
            <span className='wsw-subtitle'>
              Select a MOP or status value to open the MOP dashboard with that status pre-filtered.
            </span>
          </div>
        </div>
        <div className='wsw-divider' />
      </div>
      <div className='wsw-contentWrap'>
        {error && !dashboardData ? (
          <div className='wsw-error'>Failed to load data.</div>
        ) : !loading && !dashboardData ? (
          <div className='wsw-message'>No data available</div>
        ) : loading && !dashboardData ? (
          <div className='wsw-loaderWrap'>
            <Loader />
          </div>
        ) : (
          <div className='wsw-gridContainer'>
            <WellStatusGrid />
          </div>
        )}
      </div>
    </div>
  );
}
